export const popoverColorPickerTheme = {
  label: 'palette.tertiary.60',
};
